// **************** common import *******************
import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { debounce } from "../../utils/redirections";
import CommonHeader from "../../components/common-header";
// ********************* common function
import { capitalizeFirstLetter } from "../../utils/redirections";

// *****************************
import Table from "../../components/table/table";
import { toast } from "react-toastify";

// ******************************** API
import { FetchNotesErrorList } from "../../redux/slices/noteserror.slice";
import { RemoveNotesAPI, DeleteMultiplenotesAPI } from "../../api/delete";
import { getFacilitiesDetails, getLocationsList, getSenderNameList } from "../../api/list";

// ********************************* inter face  ********************************
import { sortInterFace } from "../../utils/types/interFace";

// INCON
import { FiFileText } from "react-icons/fi";

//edit modal
import { NotesErrorPopup } from "./notes-popup";

//delete modal
import { ConfirmPopup } from "../../components/model-popup/confirmation-popup";
import { CustomButton } from "../../components/buttons/button";
import { WordTitle } from "../../utils/commonFunction";

// interface 
import { ChildProps } from "../../utils/types/interFace";
import { ReactSelectInput } from "../../components/select/react-select";
import { formatDateMMDDYYYY } from "../../utils";

const Index = ({ filteredAccess }: ChildProps) => {
  const dispatch: any = useDispatch();
  const [loader, setLoader] = useState<boolean>(true);
  const NotesErrorData = useSelector(
    (state: any) => state?.NotesErrorList?.NotesErrorList || {}
  );


  const [facList, setFacList] = useState([])

  // ********************for table
  //
  const [filterStatus, setFilterstatus] = useState("");

  // search
  const [showSearch, setShowSearch] = useState("");
  const [search, setSearch] = useState<string>("");
  const [senderName, setSenderName] = useState<any>([]);
  const [selectedSenderName, setSelectedSenderName] = useState<any>("");
  const [selectedlocationName, setSelectedLocationName] = useState<any>("");
  const [locationName, setLocationName] = useState<any>([]);
  const [selectedDos, setSelectedDos] = useState<null | string>("");
  const handleSearch = useCallback(debounce(setSearch, 500), []);

  // sort
  const [sort, setSort] = useState<sortInterFace>({ created_at: "desc" });

  const [limit, ] = useState<number>(15);
  const [page, setPage] = useState<number>(1);
  const [totalPage, setTotalPage] = useState<number>(1);
  const [totalRecord, setTotalRecord] = useState<number>(0);

  // editview
  const [ViewDetails, setViewDetails] = useState<any>({});
  const [modelTitle, setModelTitle] = useState<string>("");
  const [showModal, setShowModal] = useState<boolean>(false);

  // delete
  const [showDeleteModel, setShowDeleteModel] = useState<boolean>(false);
  const [buttonLoader, setButtonLoader] = useState<boolean>(false);
  const [selectedRows, setSelectedRows] = useState<any>([]);
  const [multiDelete, setMultiDelete] = useState<any>(false);

  // handle the loading the data
  const handleNotesErrorData = (
    load: boolean,
    sorting: any = {},
    pageNumber?: number,
    dos?: string | null,
    senderName?: string | null,
    locationName?: string | null
  ) => {
    pageNumber && setPage(pageNumber);
    if (pageNumber || page === 1) {
      setLoader(load);
      setSelectedRows([])
    }
    console.log("Params",{
        page: pageNumber || page,
        limit,
        status: filterStatus,
        sort_by:
          Object.keys(sorting).length !== 0
            ? Object.keys(sorting)[0]
            : "created_at",
        sort_dir:
          Object.keys(sorting).length !== 0
            ? sorting[Object.keys(sorting)[0]]
            : "desc",
        search_value: search,
        date_of_service: dos === null ? null : dos ||  selectedDos,
        sender_name: senderName ||  selectedSenderName,
        location_name: locationName || selectedlocationName,
      })
    dispatch(
      FetchNotesErrorList({
        page: pageNumber || page,
        limit,
        status: filterStatus,
        sort_by:
          Object.keys(sorting).length !== 0
            ? Object.keys(sorting)[0]
            : "created_at",
        sort_dir:
          Object.keys(sorting).length !== 0
            ? sorting[Object.keys(sorting)[0]]
            : "desc",
        search_value: search,
        date_of_service: dos === null ? null : dos || selectedDos,
        sender_name: senderName === null ? null: senderName || selectedSenderName,
        location_name: locationName === null ? null:  locationName || selectedlocationName,
      })
    ).then((res: any) => {
      setTotalPage(res?.payload?.result?.total_pages);
      setTotalRecord(res?.payload?.result?.total_count);
      setLoader(false);
    });
  };

  const handleNextPage = () => {
    setPage(page + 1);
  };

  const afterChangeNotesList = () => {
    if (page === 1) {
      handleNotesErrorData(true, sort);
    } else {
      setPage(1);
    }
  };

  const handleDelete = async () => {
    setButtonLoader(true);
    await RemoveNotesAPI(ViewDetails?.id).then((res: any) => {
      setShowDeleteModel(false);
      if (res?.result?.success) {
        handleSearch([]);
        setShowSearch("");
        afterChangeNotesList();
        setMultiDelete(false)
        setViewDetails({});
        toast.success(res?.result?.message);
      } else {
        toast.error(res?.message || "User delete failed");
      }
      setButtonLoader(false);
    });
  };

  const handleMultiDelete = async () => {
    setButtonLoader(true);
    const selectedIds = selectedRows.map((row: any) => row?.id);
    const notes_list = { list_notes_id: selectedIds };
    await DeleteMultiplenotesAPI(notes_list).then(async (res: any) => {
      setShowDeleteModel(false);
      if (res?.success) {
        setViewDetails({});
        setMultiDelete(false);
        setSelectedRows([]);
        afterChangeNotesList()
        toast.success(res?.message);
      } else {
        toast.error(res?.message || res?.detail?.message || "Users delete failed");
      }
      setButtonLoader(false);
    });
  };

  
  const handleSelect = (e: any) => {
    setFilterstatus(e.target.value)
  }

  /**
     * @function handleFaclities
     * @returns
     * @description handle faclities
     * */
  const handleFaclities = async () => {
    try {
      const result = await getFacilitiesDetails();
      if (result?.result) {
        setFacList(result?.result?.data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const redirectNotesPage = (row: any) => {
    window.open(`/notes/${row?.id}`, '_blank');
  }

  const handleSenderName = async () => {
    try {
      const result = await getSenderNameList();
      if (result?.result) {
        const senderNameOptions = result?.result?.map((item: any) => ({
          label: item,
          value: item,
        }));
        setSenderName(senderNameOptions);
      }
    } catch (error) {
      console.error("Error fetching sender names:", error);
    }
  };

  const handleLocationName = async () => {
    try {
      const result = await getLocationsList();
      if (result?.result) {
        const locationOptions = result?.result?.map((item: any) => ({
          label: item,
          value: item,
        }));
        setLocationName(locationOptions);
      }
    } catch (error) {
      console.error("Error fetching locations:", error);
    }
  };


  // all use effect function
  useEffect(() => {
    handleFaclities();
    handleSenderName();
    handleLocationName();

  }, [])

  useEffect(() => {
    handleNotesErrorData(true, sort);
  }, [page]);

  useEffect(() => {
    page === 1 ? handleNotesErrorData(true, sort) : setPage(1);
  }, [limit, search, filterStatus]);

  useEffect(() => {
    handleSearch(showSearch);
  }, [showSearch]);

  // status colour
  const getStatusClass = (status: string): string => {
    switch (status.toLowerCase()) {
      case "pending":
        return "bg-slate-100 border-slate-500 text-slate-800";
      case "removed":
        return "bg-yellow-100 border-yellow-500 text-yellow-800";
      case "completed":
        return "bg-green-100 border-green-500 text-green-800";
      case "updated":
        return "bg-blue-100 border-blue-500 text-blue-800";
      case "error":
        return "bg-red-100 border-red-500 text-red-800";
      case "sent":
        return "bg-purple-100 border-purple-500 text-purple-800";
      default:
        return "bg-gray-100 border-gray-500 text-gray-800 ";
    }
  };

  interface StatusCellProps {
    status?: string;
  }

  const handleSenderNameChange = (selectedOption: any) => {
    setSelectedSenderName(selectedOption ? selectedOption.value : "");
    handleNotesErrorData(true, sort, 1, selectedDos, 
      selectedOption ? selectedOption.value : null, selectedlocationName);
  }

  const handleLocationNameChange = (selectedOption: any) => {
    setSelectedLocationName(selectedOption ? selectedOption.value : "");
    handleNotesErrorData(true, sort, 1, selectedDos, selectedSenderName,
       selectedOption ? selectedOption.value : null);
  }

  const StatusCell: React.FC<StatusCellProps> = ({ status }) => {
    return (
      <div
        className={`max-w-[500px] truncate cursor-default px-1.5 py-1 
          rounded-lg text-sm text-center font-medium border ${getStatusClass(
          status || ""
        )}`}
      >
        {status || "Unknown"}
      </div>
    );
  };

  return (
    <div className="w-full p-[10px] pl-[2px] pr-[2px]">
      <div className="pt-[16px]  pl-[2px] pr-[2px] bg-white rounded-[12px]">
        <CommonHeader
          heading="All Notes"
          description="View the full list of notes in the system."
          totalCount={totalRecord}
          countForText="Results"
          options={["Pending", "Error", "Updated", "Reprocess","Completed"]}
          handleSelect={handleSelect}
          setShowSearch={setShowSearch}
          showSearch={showSearch}
          searchDropdown
        />
        <div className="flex justify-between items-center mb-[16px]">
          <div className="flex  gap-[16px] items-center">
            <ReactSelectInput
              name="limit"
              onChange={(e: any) => {
                handleSenderNameChange(e);
              }}
              options={senderName}
              placeholder="Select Sender Name"
              className="w-[250px]"
              isSearchable={true}
              isClearable={true}
              isDisabled={false}
            />
            <ReactSelectInput
              name="limit"
              onChange={(e: any) => {
                handleLocationNameChange(e);
              }}
              options={locationName}
              placeholder="Select Location Name"
              className="w-[250px]"
              isSearchable={true}
              isClearable={true}
              isDisabled={false}
            />

            <input
              type="text"
              placeholder="Select DOS"
              onFocus={(e) => (e.target.type = "date")}
              onBlur={(e) => {
                if (!e.target.value) e.target.type = "text";
              }}
              value={selectedDos ?? ""}
              onChange={(e) => {
                const value = e.target.value;
                setSelectedDos(value);

                handleNotesErrorData(true, sort, 1, formatDateMMDDYYYY(value));
              }}
              className="w-[250px] h-[40px] border border-gray-300 rounded-md px-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            {selectedDos && selectedDos !== "" ? (
              <p className="text-[red] cursor-pointer" onClick={(e) => {
                setSelectedDos(null)
                handleNotesErrorData(true, sort, 1, null);
              }}>Clear</p>
            ) : null}
          </div>
          {/* select with search react select */}

        </div>
        <Table
          loading={loader}
          data={NotesErrorData}
          tableScroll={"100%"}
          sort={true}
          Clickable={true}
          rowClick={(row: any) => {
            redirectNotesPage(row)
          }}
          hasNextPage={page < totalPage}
          NextPageData={handleNextPage}
          columns={[
            "Patient",
            "DOB",
            "Gender",
            "Sender",
            "Location",
            "DOS",
            "Description",
            "Status",
            'Action'
          ]}
          sortTitleKeys={{
            Patient: "patient_last_name",
            Sender: "sender_name",
            Location: "location",
            DOS: "encounter_date",
            Gender: "gender",
            Status: "status"
          }}
          handleSortfunc={(key: any, value: any) => {
            setSort({ [key]: value });
            page === 1
              ? handleNotesErrorData(false, { [key]: value })
              : handleNotesErrorData(false, { [key]: value }, 1);
          }}
          scopedSlots={{
            Patient: ({ row }: any) => (
              <td title={`${row?.patient_last_name || ""} ${row?.patient_first_name || ""}`}>
                {row?.patient_detail?.patient_id ? (
                  <a
                    href={`/patient-lookup/${row?.patient_detail?.patient_id}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="underline text-blue-500"
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                  >
                    <div className="max-w-[200px] truncate cursor-pointer">
                      {![null, ""].includes(row.patient_last_name) &&
                        ![null, ""].includes(row.patient_first_name)
                        ? `${WordTitle(row.patient_last_name)}, ${WordTitle(row.patient_first_name)}`
                        : WordTitle(row.patient_last_name) || WordTitle(row.patient_first_name)}
                    </div>
                  </a>
                ) : (
                  <div className="max-w-[200px] truncate cursor-pointer">
                    {![null, ""].includes(row.patient_last_name) &&
                      ![null, ""].includes(row.patient_first_name)
                      ? `${WordTitle(row.patient_last_name)}, ${WordTitle(row.patient_first_name)}`
                      : WordTitle(row.patient_last_name) || WordTitle(row.patient_first_name)}
                  </div>
                )}
              </td>
            ),
            Sender: ({ row }: any) => (
              <td title={row?.sender_name || ""}>
                <div className=" max-w-[200px] truncate cursor-pointer">
                  {WordTitle(row?.sender_name || "")}
                </div>
              </td>
            ),
            Location: ({ row }: any) => (
              <td title={row?.location || ""}>
                <div className=" max-w-[150px] truncate cursor-pointer">
                  {WordTitle(row?.location || "")}
                </div>
              </td>
            ),
            DOS: ({ row }: any) => (
              <td title={row?.encounter_date || ""}>
                <div className=" max-w-[150px] truncate cursor-pointer">
                  {row?.encounter_date || ""}
                </div>
              </td>
            ),
            DOB: ({ row }: any) => (
              <td title={row?.DOB || ""}>
                <div className=" max-w-[150px] truncate cursor-pointer">
                  {row?.DOB || ""}
                </div>
              </td>
            ),
            Gender: ({ row }: any) => (
              <td title={row?.gender || ""}>
                <div className=" max-w-[150px] truncate cursor-pointer">
                  {row?.gender ? WordTitle(row?.gender) : ''}
                </div>
              </td>
            ),
            Description: ({ row }: any) => (
              <td title={row?.error || ""}>
                <div
                  className=" max-w-[150px] truncate cursor-pointer"
                  title={row?.status =="completed"? (row?.is_system_corrected ?  (row?.description || ""): ""): (row?.error || "")}
                >
                  {row?.status =="completed"? (row?.is_system_corrected ?  (row?.description || ""): ""): (row?.error || "")}
                </div>
              </td>
            ),
            Status: ({ row }: any) => (
              <td>
                <StatusCell status={capitalizeFirstLetter(row.status)} />
              </td>
            ),
            Action: ({ row }: any) => {
              return (
                <td>
                  <div className="flex gap-[16px] items-center justify-center pr-[4px]">

                    <a
                      href={`/notes/${row.id}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="no-underline"
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                    >
                      <FiFileText fontWeight={900} fontSize={22} title="Notes Content" />
                    </a>
                  </div>
                </td>
              );
            },
          }}
        />

        {/*  editeing modal ***********/}
        {showModal ? (
          <NotesErrorPopup
            showModal={showModal}
            setShowModal={setShowModal}
            afterChangeNotesList={afterChangeNotesList}
            handleClose={() => {
              setViewDetails({});
              //  setDecrypt("");
              setShowModal(false);
              //  setViewPopup(false);
            }}
            title={modelTitle}
            setTitle={setModelTitle}
            poupDetails={ViewDetails}
            facList={facList}
          />
        ) : null}

        <ConfirmPopup showModal={showDeleteModel} icon>
          <div className="text-[16px] font-semibold text-center text-[#061018] line-height-[24px]">
            Remove Notes?
          </div>
          <div className="text-[12px] font-normal text-center text-[#061018] mt-[8px] mb-[16px] ">
            You are about to delete{" "}
            <span className="font-semibold">
              {multiDelete
                ? `${selectedRows?.length} notes`
                : `“${ViewDetails?.mrn}(MRN)” notes`}
            </span> {" "}
            Are you sure you want to continue?
          </div>
          <div className="flex justify-center gap-[16px] items-center w-full">
            <CustomButton
              buttonName="No, Keep it"
              primary={false}
              buttonStyle="w-full text-[#1C252D] text-[14px] p-[12px] text-[14px] font-semibold leading-[17px]   "
              disable={buttonLoader}
              onClick={() => {
                setShowDeleteModel(false);
                setViewDetails({});
              }}
            />
            <CustomButton
              buttonName="Yes, Remove !"
              buttonStyle="w-full text-white bg-[#D41E1E] hover:bg-[#B51C1C] text-[14px] p-[12px] text-[14px] font-semibold leading-[17px]   "
              loader={buttonLoader}
              disable={buttonLoader}
              loaderStyle="w-full bg-[#D41E1E]/80  py-[13px] "
              onClick={() => {
                multiDelete ? handleMultiDelete() : handleDelete();
              }}
            />
          </div>
        </ConfirmPopup>
      </div>
    </div>
  );
};

export default Index;
